export default __webpack_public_path__ + "static/media/BCA35.f8e14ec5.jpg";